module.exports = __webpack_public_path__ + "bin/362d500fae739df20745c0686efe0b6b.png";